import { $FIXME } from '../../constants';

export const addImageFallback = (event: $FIXME) => {
    event.currentTarget.src = '/images/image-not-available.svg';
};
